import './App.css';
import { AppRouter } from './router/AppRouter';
import { useAppInit } from './shared/hooks/useAppInit';
import { useTabSync } from './shared/hooks/useTabSync';
import {
    checkCurrentTabUniqueness,
    debug,
    initUniqueTabData,
} from './shared/lib/general';
import { refreshLocalStorage } from './shared/lib/stateStorage';

debug(`App v. ${APP_VERSION}`);
refreshLocalStorage(APP_VERSION);

initUniqueTabData();
const { tabId } = checkCurrentTabUniqueness();

function App() {
    useAppInit();
    useTabSync(tabId);

    return (
        <div className="App">
            <AppRouter />
        </div>
    );
}

export { App };
